import {
	SET_LOCALE,
	UPDATE_CONNECTION_STATUS,
	LIST_USER_NOTIFICATIONS,
	SET_NOTIFICATION_STATUS,
	PREPEND_NEW_NOTIFICATION,
	SET_NOTIFICATIONS_COUNTER,
	LOG_EVENT,
	RESET_LOGS,
	UPDATE_EVENT_DURATION,
} from "./action-types";
import { en } from "../../../resources/en";
import { ar } from "../../../resources/ar";
import { urdu } from "../../../resources/urdu";
import { pa } from "../../../resources/pa";

/**
 * Module internal initial state
 */
const initialState = {
	currentLocale: null,
	currentResource: null,
	connectionStatus: false,
	currentDirection: null,
	notificationsList: [],
	notificationsCount: 0,
	events: [],
};

/**
 * Check dispatched action and update state accordingly
 * @param {Object} state
 * @param {Object} action
 * @returns {Function}
 */

const reducer = (state = initialState, { type, payload = null }) => {
	switch (type) {
		case SET_LOCALE:
			return setLocale(state, payload);
		case UPDATE_CONNECTION_STATUS:
			return updateConnectionStatus(state, payload);
		case LIST_USER_NOTIFICATIONS:
			return setNotificationsList(state, payload);
		case SET_NOTIFICATION_STATUS:
			return setNotificationStatus(state, payload);
		case PREPEND_NEW_NOTIFICATION:
			return addNewNotification(state, payload);
		case SET_NOTIFICATIONS_COUNTER:
			return setNotificationsCounter(state, payload);
		case LOG_EVENT:
			return logEvent(state, payload);
		case UPDATE_EVENT_DURATION:
			return updateEventDuration(state, payload);
		case RESET_LOGS:
			window.localStorage.setItem("events", []);
			return { ...state, events: [] };
		default:
			return state;
	}
};

function setLocale(state, payload) {
	localStorage.setItem("currentLocale", payload);
	return {
		...state,
		currentLocale: payload,
		currentResource:
			payload === "english"
				? en
				: payload === "ar"
				? ar
				: payload === "urdu"
				? urdu
				: pa,
		currentDirection: payload === "en" ? "ltr" : "rtl",
	};
}

function updateConnectionStatus(state, payload) {
	return {
		...state,
		connectionStatus: payload,
	};
}

function setNotificationsList(state, payload) {
	return {
		...state,
		notificationsList: payload.list,
	};
}

function setNotificationStatus(state, payload) {
	let index;
	let notificationsList = state.notificationsList;
	for (const prop in notificationsList) {
		if (prop === payload.key) {
			index = notificationsList[prop].findIndex(
				(notification) => notification.notificationID === payload.id
			);
			if (index > -1) {
				notificationsList[prop][index].isSeen = true;
			}
		}
	}
	return {
		...state,
		notificationsList,
		notificationsCount: state.notificationsCount - 1,
	};
}

function addNewNotification(state, payload) {
	let notificationsList = state.notificationsList;
	for (const date in notificationsList) {
		if (payload.incomingDate === date) {
			console.log(date);
		}
	}

	return {
		...state,
		notificationsCount: state.notificationsCount + 1,
	};
}

function setNotificationsCounter(state, payload) {
	return {
		...state,
		notificationsCount: payload,
	};
}

function logEvent(state, payload) {
	let eventIndex = state.events.findIndex(
		(ev) => ev.data.id === payload.data.id
	);
	if (eventIndex === -1) {
		window.localStorage.setItem("events", JSON.stringify(state.events));
		return {
			...state,
			events: [...state.events, payload],
		};
	} else {
		return state;
	}
}

function updateEventDuration(state, payload) {
	let eventIndex = state.events.findIndex((ev) => ev.data.id === payload);
	let events = state.events;
	if (eventIndex > -1) {
		events[eventIndex].data.duration++;
	}
	window.localStorage.setItem("events", JSON.stringify(state.events));
	return {
		...state,
		events,
	};
}

export default reducer;
